import type { ProductUpdate } from '../models/whatsNew.types'

export const WHATS_NEW_TTL_MS = 60 * 60 * 1000

export function sortUpdates(updates: readonly ProductUpdate[]): ProductUpdate[] {
  return [...updates].sort(
    (left, right) =>
      Date.parse(right.published_at || right.created_at) -
      Date.parse(left.published_at || left.created_at),
  )
}

export function hasUnseenUpdates(
  updates: readonly ProductUpdate[],
  lastSeenAt: number | null,
): boolean {
  const newest = sortUpdates(updates)[0]
  if (!newest) return false
  if (lastSeenAt === null) return true
  const publishedAt = Date.parse(newest.published_at || newest.created_at)
  return Number.isFinite(publishedAt) && publishedAt > lastSeenAt
}

export function shouldRefetch(
  fetchedAt: number | null,
  now = Date.now(),
  ttlMs = WHATS_NEW_TTL_MS,
): boolean {
  return fetchedAt === null || now - fetchedAt >= ttlMs
}
